import styled from "styled-components";

export const Title = styled.span`
  font-family: "FrankfurterEF-Medium";
  font-size: 3rem;
  text-align: center;
  margin-bottom: 3rem;
  @media (max-width: 600px) {
    font-size: 2rem;
  }
`;
export const StyledText = styled.span`
  color: rgba(0, 0, 0, 0.7);
  font-family: "Avenir-Medium";
  text-align: center;
  font-size: 2rem;
  line-height: 3.2rem; /* 160% */
`;

export const Gap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
export const ButtonYes = styled.button`
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 5px;
  background-color: #484888;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  border-radius: 20px;
  min-width: 150px;

  font-family: "Avenir-Heavy", sans-serif;
  font-size: 16px;
  letter-spacing: -0.177777px;
  color: #fff;
  cursor: ${(props) => (props.loading ? "default" : "pointer")};

  &:active {
    transition: scale 0.3s ease-in;
    transform: ${(props) => (props.loading ? "unset" : "scale(0.95)")};
    -webkit-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0);
    -moz-box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0);
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0);
  }
`;

export const ButtonNo = styled(ButtonYes)`
  background-color: white;
  border: 2px solid #484888;

  padding: 12px;
  color: #484888;
`;

export const CloseContainer = styled.div`
  border-radius: 1rem;
  background: #484888;
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  width: 5.5rem;
  height: 5.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -1rem;
  left: -1rem;
  @media (max-width: 870px) {
    top: 8rem;
    right: 1rem;
    left: unset;
  }
`;
